export const SEARCH_TYPES = [
  { key: "journey", label: "Journeys" },
  { key: "team", label: "Teams" },
  { key: "city", label: "Talukas / Towns" },
  { key: "contact", label: "Contacts" },
  { key: "accommodation", label: "Accommodation" },
  { key: "prasadam", label: "Prasadam" },
  { key: "story", label: "Stories" },
  { key: "advice", label: "Advice" },
  { key: "knowledge", label: "Knowledge" },
];

export const SEARCH_TYPE_LABEL = {
  journey: "Journeys",
  team: "Teams",
  city: "Talukas / Towns",
  contact: "Contacts",
  accommodation: "Accommodation",
  prasadam: "Prasadam",
  story: "Stories",
  advice: "Advice",
  knowledge: "Knowledge",
  forum: "Forum",
  media: "Media",
};
